import React, { useState, useEffect, useCallback } from 'react';
import './agendamento.css';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faAngleLeft, faAngleRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Modal from '../../components/modal/index';
import ConfirmModal from '../../components/modal/confirmModal';
import { useInternals } from '../../context/internalContext';
import { useAuxiliaries } from '../../context/auxiliariesContext';
import { useUsers } from '../../context/usersContext';
import { useUnits } from '../../context/unitsContext';
import { toast } from 'react-toastify';
import Header from '../../components/header';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import Titulo from '../../components/Titulo/titulo';


export default function Schedule() {
  const navigate = useNavigate();

  // Estados e funções para gerenciar os dados do usuário, internos, e agendamentos
  const { userInfo, buildUnitReadParams, effectiveUnitId } = useUsers();
  const { createSchedule, listSchedule, updateSchedule } = useInternals();
  const { listScheduling } = useAuxiliaries();
  const { listLocations } = useUnits();

  // Estados para gerenciar a data atual, dias do mês, modais, agendamentos e formData
  const [currentDate, setCurrentDate] = useState(new Date());
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [locations, setLocations] = useState([]);
  const [isVirtual, setIsVirtual] = useState(false);  // Checkbox de virtual
  const [observation, setObservation] = useState('');  // Para observações adicionais
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [reasonInactivation, setReasonInactivation] = useState('');// Estado para o motivo do cancelamento
  const [isLoading, setIsLoading] = useState(false); // Estado de loading para requisições
  const [isSubmittingAppointment, setIsSubmittingAppointment] = useState(false);

  const [isDayView, setIsDayView] = useState(false);
  const [selectedDayDate, setSelectedDayDate] = useState(null);
  const [selectedDayAppointments, setSelectedDayAppointments] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [appointmentsCount, setAppointmentsCount] = useState(0);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false); // Modal de confirmação de atendimento
  const [isCancelConfirmModalOpen, setIsCancelConfirmModalOpen] = useState(false); // Modal de confirmação de cancelamento

  const [scheduleTypes, setScheduleTypes] = useState([]);
  const [selectedInternal, setSelectedInternal] = useState(null);
  const [showOnlyVirtual, setShowOnlyVirtual] = useState(false); // Filtro: somente atendimentos virtuais

  // Estado para armazenar os dados do formulário de agendamento
  const [formData, setFormData] = useState({
    type_schedule: '',
    start_date: '',
    internal: '',
  });

  const handleInternalSelect = (internal) => {
    if (!internal?.id) {
      toast.error("Erro ao selecionar interno.");
      return;
    }

    setSelectedInternal(internal); // Define o interno selecionado
    setFormData(prevFormData => ({
      ...prevFormData,
      internal: internal.id, // Define o ID do interno no formulário
    }));
  };

  const toDateKey = useCallback((date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }, []);

  const getAppointmentsByDate = useCallback((dateKey) => {
    return appointments
      .filter((appointment) => appointment.start_date && appointment.start_date.startsWith(dateKey))
      .filter((appointment) => !showOnlyVirtual || appointment.virtual)
      .sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
  }, [appointments, showOnlyVirtual]);


  // Função para gerar os dias do mês atual no calendário
  const generateCalendar = useCallback(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDayOfMonth = new Date(year, month, 1).getDay();
    const lastDateOfMonth = new Date(year, month + 1, 0).getDate();

    const daysArray = [];

    // Preenche os dias vazios no início do mês
    for (let i = 0; i < firstDayOfMonth; i++) {
      daysArray.push(null);
    }

    // Preenche os dias do mês
    for (let i = 1; i <= lastDateOfMonth; i++) {
      daysArray.push(i);
    }

    setDaysInMonth(daysArray);
  }, [currentDate]);

  // Função para buscar internos, tipos de agendamento e agendamentos existentes
  const fetchInternalsAndSchedules = useCallback(async () => {
    try {
      // Determina o primeiro e o último dia do mês atual
      const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

      // Parâmetros para listar agendamentos
      const params = buildUnitReadParams({
        limit: 1000,
        start: startOfMonth.toISOString().split('T')[0],
        end: endOfMonth.toISOString().split('T')[0],
      });

      // Busca tipos de agendamento
      const scheduleTypesResponse = await listScheduling();
      const HUMANIZACAO_KEYWORDS = ['PSICOLOGIA', 'SAUDE', 'SERVICO SOCIAL', 'ODONTOLOGIA', 'EDUCACAO', 'NUTRICAO', 'VISITA VIRTUAL'];
      const normalizeStr = (str) => str?.toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '') ?? '';
      const allTypes = Array.isArray(scheduleTypesResponse.results) ? scheduleTypesResponse.results : [];
      setScheduleTypes(allTypes.filter(type => HUMANIZACAO_KEYWORDS.some(kw => normalizeStr(type.name).includes(kw))));

      // Busca agendamentos
      const appointmentsResponse = await listSchedule(params);
      setAppointments(Array.isArray(appointmentsResponse.results) ? appointmentsResponse.results : []);
      setAppointmentsCount(appointmentsResponse.count ?? 0);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      toast.error('Erro ao carregar dados.');
    }
  }, [currentDate, listScheduling, listSchedule, buildUnitReadParams]);

  // Função para Buscar Locais ao Carregar:
  const fetchLocations = useCallback(async () => {
    try {
      const locationsResponse = await listLocations();
      setLocations(locationsResponse.results);
    } catch (error) {
      console.error('Erro ao carregar locais:', error);
    }
  }, [listLocations]);

  // Efeito para gerar o calendário e buscar dados ao carregar o componente
  useEffect(() => {
    generateCalendar();
    fetchInternalsAndSchedules();
    fetchLocations();
  }, [currentDate, generateCalendar, fetchInternalsAndSchedules, fetchLocations, effectiveUnitId]);


  // Função chamada ao clicar em um dia no calendário
  const handleDayClick = (day, e) => {
    if (e?.target.classList.contains('appointment-tag')) {
      return;
    }

    const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
    const isoDate = toDateKey(date);
    const appointmentsOnDay = getAppointmentsByDate(isoDate);

    setFormData({
      ...formData,
      start_date: isoDate,
      type_schedule: '',
      internal: '',
    });

    setSelectedDayDate(date);
    setSelectedDayAppointments(appointmentsOnDay);
    setIsDayView(true);
  };

  // Função para fechar o modal de criação de agendamento
  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({
      type_schedule: '',
      start_date: '',
      internal: '',
    });
    setSelectedInternal('');
    setIsVirtual(false);
    setObservation('');
    setStartTime('');
    setEndTime('');
  };

  // Função para abrir o modal de visualização de agendamento
  const openViewModal = (appointment) => {
    setSelectedAppointment(appointment);
    setIsViewModalOpen(true);
  };

  // Função para fechar o modal de visualização de agendamento
  const closeViewModal = () => {
    setIsViewModalOpen(false);
    setSelectedAppointment(null);
    setReasonInactivation(''); // Limpa motivo ao fechar modal de visualização
  };

  // Função para manipular a mudança nos campos do formulário
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: value,
    }));

    // Visita virtual já marca automaticamente o atendimento como virtual
    if (name === 'type_schedule') {
      const selectedType = scheduleTypes.find(type => String(type.id) === String(value));
      if (selectedType?.name === 'VISITA VIRTUAL') {
        setIsVirtual(true);
      }
    }
  };


  // Função para gerar horários em múltiplos de 30 minutos nos intervalos restritos
  const generateTimeSlots = (isEndTime = false) => {
    const times = [];

    // Intervalo 1: 9:30 - 11:00 (exclui 9:00 para horários de término)
    let start = isEndTime ? 9 * 60 + 30 : 9 * 60;
    const endMorning = isEndTime ? 11 * 60 + 30 : 11 * 60;

    while (start < endMorning) {
      const hours = Math.floor(start / 60);
      const minutes = start % 60;
      const time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      times.push(time);
      start += 30;
    }

    // Intervalo 2: 14:30 - 16:30 (exclui 14:00 para horários de término)
    start = isEndTime ? 14 * 60 + 30 : 14 * 60;
    const endAfternoon = isEndTime ? 16 * 60 + 60 : 16 * 60 + 30; // 17:00 para término, 16:30 para início

    while (start < endAfternoon) {
      const hours = Math.floor(start / 60);
      const minutes = start % 60;
      const time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      times.push(time);
      start += 30;
    }

    return times;
  };

  // Função para enviar os dados do formulário ao backend e criar um novo agendamento
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmittingAppointment) return;

    // Validações obrigatórias
    if (!formData.internal) {
      toast.warn('Selecione um interno antes de salvar.');
      return;
    }
    if (!formData.type_schedule) {
      toast.warn('Selecione o tipo de atendimento.');
      return;
    }
    if (!startTime || !endTime) {
      toast.warn('Selecione os horários de início e término.');
      return;
    }

    // Montar o start_date e end_date combinando a data e os horários
    const startDateTime = `${formData.start_date}T${startTime}:00`;
    const endDateTime = `${formData.start_date}T${endTime}:00`;

    const payload = {
      ...formData,
      start_date: startDateTime,
      end_date: endDateTime,
      user: parseInt(userInfo.id),
      virtual: isVirtual,
      observation: observation,
    };

    setIsSubmittingAppointment(true);
    try {
      await createSchedule(payload);
      await fetchInternalsAndSchedules(); // recarrega lista com dados completos
      closeModal();
    } catch (error) {
      console.error('Erro ao agendar:', error.message);
    } finally {
      setIsSubmittingAppointment(false);
    }
  };


  const closeDayView = () => {
    setIsDayView(false);
    setSelectedDayDate(null);
    setSelectedDayAppointments([]);
  };

  useEffect(() => {
    if (!isDayView || !selectedDayDate) return;
    const dateKey = toDateKey(selectedDayDate);
    setSelectedDayAppointments(getAppointmentsByDate(dateKey));
  }, [appointments, isDayView, selectedDayDate, toDateKey, getAppointmentsByDate]);

  // Função para abrir o modal de confirmação antes de realizar o atendimento
  const openConfirmModal = () => {
    setIsConfirmModalOpen(true);
    setIsViewModalOpen(false);
  };

  // Função para fechar o modal de confirmação
  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  // Função para abrir modal de cancelamento
  const openCancelConfirmModal = () => {
    setIsCancelConfirmModalOpen(true);
  };

  // Função para fechar modal de cancelamento
  const closeCancelConfirmModal = () => {
    setIsCancelConfirmModalOpen(false);
  };

  // Função chamada ao clicar em "Realizar atendimento"
  const handleAttendClick = () => {
    openConfirmModal();
  };

  // Função que centraliza a verificação de permissão do usuário para o tipo de agendamento
  const hasPermissionForType = (typeName) => {
    if (!userInfo?.groups || !typeName) return false;

    const groupMap = {
      'PSICOLOGIA': 'PSICOLOGIA',
      'SAUDE': ['ENFERMAGEM', 'MEDICINA'],
      'SERVIÇO SOCIAL': 'SERVICO SOCIAL',
      'ODONTOLOGIA': 'ODONTOLOGIA',
      'EDUCAÇAO': 'EDUCACAO',
      'NUTRIÇAO': 'NUTRICAO',
      'VISITA VIRTUAL': ['ADMINISTRATIVO', 'SERVICO SOCIAL'],
    };

    for (const key in groupMap) {
      const normalizedType = typeName?.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      const normalizedKey = key.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      if (normalizedType.includes(normalizedKey)) {
        return userInfo.groups.some(g => {
          const normalizedGroup = g.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
          if (Array.isArray(groupMap[key])) {
            return groupMap[key].some((target) => {
              const normalizedTarget = target.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
              return normalizedGroup === normalizedTarget;
            });
          }
          const normalizedTarget = groupMap[key].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
          return normalizedGroup === normalizedTarget;
        });
      }
    }

    return false;
  };

  // Função para confirmar o atendimento, atualizando o status e redirecionando o usuário
  const handleConfirmAttend = async () => {
    if (selectedAppointment) {
      // Bloqueia se usuário não tem permissão para o tipo de atendimento
      if (!hasPermissionForType(selectedAppointment.type_schedule_name)) {
        toast.error('Você não tem permissão para realizar este atendimento.');
        closeConfirmModal();
        return;
      }
      const { internal, type_schedule_name } = selectedAppointment;

      // Visita virtual não redireciona: marca o agendamento como realizado diretamente
      if (type_schedule_name === 'VISITA VIRTUAL') {
        try {
          await updateSchedule(selectedAppointment.id, { done: true });
          await fetchInternalsAndSchedules();
          toast.success('Atendimento realizado com sucesso!');
          closeConfirmModal();
          closeViewModal();
        } catch (error) {
          console.error('Erro ao realizar o atendimento:', error);
          toast.error('Erro ao realizar o atendimento.');
        }
        return;
      }

      try {
        // Redireciona o usuário para a página correta com base no tipo de agendamento
        let path = '';
        switch (type_schedule_name) {
          case 'PRIMEIRO ATENDIMENTO PSICOLOGIA':
          case 'EVOLUÇAO PSICOLOGIA':
            path = '/psicologia';
            break;
          case 'PRIMEIRO ATENDIMENTO SAUDE':
          case 'EVOLUÇAO SAUDE':
            path = '/admissao';
            break;
          case 'PRIMEIRO ATENDIMENTO SERVIÇO SOCIAL':
          case 'EVOLUÇAO SERVIÇO SOCIAL':
            path = '/servico-social';
            break;
          case 'PRIMEIRO ATENDIMENTO ODONTOLOGIA':
          case 'EVOLUÇAO ODONTOLOGIA':
            path = '/odontologia';
            break;
          case 'PRIMEIRO ATENDIMENTO EDUCAÇAO':
          case 'EVOLUÇAO EDUCAÇAO':
            path = '/educacao';
            break;
          case 'PRIMEIRO ATENDIMENTO NUTRIÇAO':
          case 'EVOLUÇAO NUTRIÇAO':
            path = '/nutricao';
            break;
          default:
            path = '';
            break;
        }
        navigate(path, { state: { internalId: internal } });
        closeConfirmModal(); // Fecha o modal de confirmação
      } catch (error) {
        console.error('Erro ao realizar o atendimento:', error);
      }
    }
  };

  // função para cancelar agendamento
  const handleCancelAppointment = async () => {
    if (selectedAppointment) {
      if (!reasonInactivation) {
        toast.warn('Por favor, insira um motivo para o cancelamento.');
        return;
      }
      if (reasonInactivation.trim().length < 10) {
        toast.warn('O motivo do cancelamento deve ter pelo menos 10 caracteres.');
        return;
      }
      setIsLoading(true);
      try {
        await updateSchedule(selectedAppointment.id, {
          active: false,
          reason_inactivation: String(reasonInactivation || '').trim(),
        });
        setAppointments(prevAppointments =>
          prevAppointments.map(appointment =>
            appointment.id === selectedAppointment.id
              ? {
                ...appointment,
                active: false,
                status: 'Cancelado',
                reason_inactivation: reasonInactivation
              }
              : appointment
          )
        );
        await fetchInternalsAndSchedules();
        toast.success('Agendamento cancelado com sucesso!');
        setReasonInactivation('');
        closeCancelConfirmModal();
        closeViewModal();
      } catch (error) {
        // Mostra mensagem detalhada do backend, se disponível
        const msg = error?.response?.data?.detail || error?.message || 'Erro ao cancelar o agendamento.';
        toast.error(msg);
      } finally {
        setIsLoading(false);
      }
    }
  };

  // Função para renderizar botões de ação, considerando permissão do usuário
  const renderActionButtons = () => {
    // Verifica se o usuário logado é responsável ou se o agendamento foi criado automaticamente
    const isResponsibleUser =
      selectedAppointment &&
      (selectedAppointment.user === userInfo.id ||
        selectedAppointment.user_name === 'Automatico');
    // Verifica se o agendamento já foi atendido (done = true)
    const isNotCompleted =
      selectedAppointment && !selectedAppointment.done && selectedAppointment.active !== false;
    // Só exibe botões se for responsável, não concluído e tiver permissão para o tipo
    const hasPermission = selectedAppointment && hasPermissionForType(selectedAppointment.type_schedule_name);

    if (isResponsibleUser && isNotCompleted && hasPermission) {
      return (
        <div className="buttons-agenda-view">
          <button className="btn-atender" onClick={handleAttendClick}>Realizar atendimento</button>
          <button className="btn-cancelar" onClick={openCancelConfirmModal}>Cancelar agendamento</button>
        </div>
      );
    }
    return null;
  };


  // Função para renderizar os agendamentos em cada dia do calendário
  const renderAppointments = (day) => {
    const dateStr = toDateKey(new Date(currentDate.getFullYear(), currentDate.getMonth(), day));
    const appointmentsOnDay = getAppointmentsByDate(dateStr);

    // Resumo por status
    const summary = {
      pending: 0,
      done: 0,
      canceled: 0,
      expired: 0,
      warning: 0,
    };

    appointmentsOnDay.forEach((appointment) => {
      if (appointment.done) {
        summary.done += 1;
      } else if (!appointment.active) {
        summary.canceled += 1;
      } else if (appointment.status === 'Vencendo') {
        summary.warning += 1;
      } else if (appointment.status === 'Vencido') {
        summary.expired += 1;
      } else {
        summary.pending += 1;
      }
    });

    return (
      <div className="appointment-summary" onClick={(e) => day && handleDayClick(day, e)}>
        {summary.pending > 0 && <span className="summary-pending">Pendentes: {summary.pending}</span>}
        {summary.done > 0 && <span className="summary-done">Atendidos: {summary.done}</span>}
        {summary.canceled > 0 && <span className="summary-canceled">Cancelados: {summary.canceled}</span>}
        {summary.warning > 0 && <span className="summary-warning">Vencendo: {summary.warning}</span>}
        {summary.expired > 0 && <span className="summary-expired">Expirados: {summary.expired}</span>}
      </div>
    );
  };

  // Funções para navegar entre os meses no calendário
  const handlePreviousMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  // funcao de cores do estaos do modal
  const getStatusDetails = (appointment) => {
    if (!appointment) return { statusClass: '', statusLabel: '' };

    const statusClass =
      appointment.done
        ? 'appointment-done' // Atendido
        : (appointment.reason_inactivation)
          ? 'appointment-canceled' // Cancelado
          : appointment.status === 'Vencido'
            ? 'appointment-expired' // Expirado
            : appointment.status === 'Vencendo'
              ? 'appointment-warning' // Vencendo
              : 'appointment-pending'; // Aguardando Atendimento

    const statusLabel =
      appointment.done
        ? 'Atendido'
        : (appointment.reason_inactivation)
          ? 'Cancelado'
          : appointment.status === 'Vencido'
            ? 'Expirado'
            : appointment.status === 'Vencendo'
              ? 'Vencendo'
              : 'Aguardando Atendimento';

    return { statusClass, statusLabel };
  };

  // Contagem exibida no header: total do mês, ou só os virtuais quando o filtro está ativo
  const visibleAppointmentsCount = showOnlyVirtual
    ? appointments.filter((appointment) => appointment.virtual).length
    : appointmentsCount;

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container'>
        <div className="schedule-header-row">
          <h4 style={{ borderBottom: '2px solid #265DAF' }} className='h4-title'>Agendamentos</h4>
          <div className="schedule-filter">
            <span className={`appointment-virtual-label ${showOnlyVirtual ? 'active' : ''}`}>Somente virtuais</span>
            <label className="appointment-virtual-toggle">
              <input
                type="checkbox"
                checked={showOnlyVirtual}
                onChange={(e) => setShowOnlyVirtual(e.target.checked)}
              />
              <span className="appointment-virtual-slider" />
            </label>
          </div>
        </div>

        <div className={`calendar-navigation ${isDayView ? 'day-mode' : ''}`}>
          {isDayView && selectedDayDate ? (
            <>
              <div className="day-view-actions">
                <button type="button" onClick={closeDayView}>
                  <FontAwesomeIcon icon={faArrowLeft} className='day-back-icon' /> Voltar para calendário
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setIsModalOpen(true);
                  }}
                >
                  <img src={PlusCircle} alt="icone" className="icon" /> Agendar
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="calendar-month-title">
                <h2>{currentDate.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })}</h2>
                <span className="calendar-month-count">
                  {visibleAppointmentsCount} agendamento{visibleAppointmentsCount === 1 ? '' : 's'}
                </span>
              </div>
              <div className="calendar-month-actions">
                <button onClick={handlePreviousMonth}>
                  <FontAwesomeIcon icon={faAngleLeft} className='i' />
                </button>
                <button onClick={handleNextMonth}>
                  <FontAwesomeIcon icon={faAngleRight} className='i' />
                </button>
              </div>
            </>
          )}
        </div>

        <div className='content'>
          {isDayView && selectedDayDate ? (
            <DayScheduleView
              selectedDayAppointments={selectedDayAppointments}
              selectedDayDate={selectedDayDate}
              getStatusDetails={getStatusDetails}
              openViewModal={openViewModal}
            />
          ) : (
            <CalendarGrid
              daysInMonth={daysInMonth}
              currentDate={currentDate}
              onDayClick={handleDayClick}
              renderAppointments={renderAppointments}
            />
          )}
        </div>

        {/* Modal de agendar */}
        <AppointmentFormModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          formData={formData}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
          scheduleTypes={scheduleTypes}
          locations={locations}
          isVirtual={isVirtual}
          setIsVirtual={setIsVirtual}
          startTime={startTime}
          setStartTime={setStartTime}
          endTime={endTime}
          setEndTime={setEndTime}
          observation={observation}
          setObservation={setObservation}
          generateTimeSlots={generateTimeSlots}
          selectedInternal={selectedInternal}
          handleInternalSelect={handleInternalSelect}
          isSubmittingAppointment={isSubmittingAppointment}
        />

        {/* Modal de visualizar agendamento */}
        <AppointmentViewModal
          isOpen={isViewModalOpen}
          closeModal={closeViewModal}
          selectedAppointment={selectedAppointment}
          renderActionButtons={renderActionButtons}
        />

        {/* Modal de confirmação para realizar atendimento */}
        <ConfirmModal
          isOpen={isConfirmModalOpen}
          closeModal={closeConfirmModal}
          onConfirm={handleConfirmAttend}
          icon={faExclamationTriangle}
          mainMessage="Tem certeza que deseja realizar esta ação?"
          secondaryMessage={
            selectedAppointment?.type_schedule_name === 'VISITA VIRTUAL'
              ? 'O agendamento será marcado como realizado.'
              : 'Você será redirecionado para o atendimento.'
          }
        />

        {/* Modal de confirmação para cancelar agendamento */}
        <ConfirmModal
          isOpen={isCancelConfirmModalOpen}
          closeModal={closeCancelConfirmModal}
          onConfirm={handleCancelAppointment}
          icon={faExclamationTriangle}
          mainMessage="Tem certeza que deseja cancelar este agendamento?"
          secondaryMessage="Essa ação não pode ser desfeita."
          loading={isLoading}
        >
          <div style={{ marginTop: '20px' }}>
            <label htmlFor="cancel-reason">Motivo do Cancelamento:</label>
            <textarea
              id="cancel-reason"
              name="reason_inactivation"
              value={reasonInactivation}
              onChange={(e) => setReasonInactivation(e.target.value)}
              placeholder="Digite o motivo do cancelamento"
              required
              rows="4"
              disabled={isLoading}
            />
          </div>
        </ConfirmModal>




      </div>
    </div >
  );
}

function DayScheduleView({ selectedDayAppointments, selectedDayDate, getStatusDetails, openViewModal }) {
  const sortedAppointments = [...selectedDayAppointments].sort(
    (a, b) => new Date(a.start_date) - new Date(b.start_date)
  );

  return (
    <div className="day-schedule-container">
      <div className="day-schedule-header">
        <p>{selectedDayDate.toLocaleDateString('pt-BR', { weekday: 'short' }).toUpperCase()}</p>
        <h3>{selectedDayDate.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })}</h3>
      </div>
      <div className="day-schedule-grid day-schedule-list">
        {sortedAppointments.map((appointment) => {
          const { statusClass, statusLabel } = getStatusDetails(appointment);
          return (
            <div
              className={`day-event-card day-card-${statusClass}`}
              key={appointment.id}
              onClick={() => openViewModal(appointment)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  openViewModal(appointment);
                }
              }}
            >
              <div>
                <p className="day-event-title">{appointment.type_schedule_name}</p>
                <p className="day-event-subtitle">{appointment.internal_name || 'Interno não informado'}</p>
              </div>
              <div className="day-event-actions">
                <span className={`appointment-item ${statusClass}`}>{statusLabel}</span>
              </div>
            </div>
          );
        })}
      </div>
      {sortedAppointments.length === 0 && (
        <p className="semDados">Não há agendamentos para este dia.</p>
      )}
    </div>
  );
}

// Subcomponente 1: CalendarGrid
function CalendarGrid({ daysInMonth, currentDate, onDayClick, renderAppointments }) {
  return (
    <div className="calendar-grid">
      <div className="calendar-header">Dom</div>
      <div className="calendar-header">Seg</div>
      <div className="calendar-header">Ter</div>
      <div className="calendar-header">Qua</div>
      <div className="calendar-header">Qui</div>
      <div className="calendar-header">Sex</div>
      <div className="calendar-header">Sáb</div>
      {daysInMonth.map((day, index) => (
        <div
          key={index}
          className={`calendar-day ${day ? 'active' : ''}`}
          onClick={(e) => day && onDayClick(day, e)}
        >
          <span>{day}</span>
          {day && renderAppointments(day)}
        </div>
      ))}
    </div>
  );
}

// Subcomponente 2: AppointmentFormModal
function AppointmentFormModal({
  isOpen,
  closeModal,
  formData,
  handleInputChange,
  handleSubmit,
  scheduleTypes,
  locations,
  isVirtual,
  setIsVirtual,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
  observation,
  setObservation,
  generateTimeSlots,
  selectedInternal,
  handleInternalSelect,
  isSubmittingAppointment,
}) {
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} title={`Agendamento para ${formData.start_date}`}>
      <div className="appointment-create-modal">
        <div className="appointment-create-block">
          <p className="appointment-details-label">Buscar interno</p>
          <Titulo
            children={
              <SearchInternal onSelect={handleInternalSelect} />
            }
          />
          <div className="appointment-selected-internal">
            <p className="appointment-details-label">Interno selecionado</p>
            {selectedInternal ? (
              <h4 className='h4-title'>{selectedInternal.name} - {selectedInternal.cpf}</h4>
            ) : (
              <p className='h4-title'>Nenhum interno selecionado</p>
            )}
          </div>
        </div>

        <form className="appointment-form appointment-create-form" onSubmit={handleSubmit}>
          <div className="appointment-details-grid">
            <div className="appointment-details-card">
              <span>Tipo de atendimento</span>
              <select name="type_schedule" value={formData.type_schedule} onChange={handleInputChange} required>
                <option value="">Selecione</option>
                {scheduleTypes.map(type => (
                  <option key={type.id} value={type.id}>{type.name}</option>
                ))}
              </select>
            </div>

            <div className="appointment-details-card appointment-virtual-card">
              <span>Atendimento virtual</span>
              <div className="appointment-virtual-field">
                <span className={`appointment-virtual-label ${!isVirtual ? 'active' : ''}`}>Não</span>
                <label className="appointment-virtual-toggle">
                  <input
                    type="checkbox"
                    name="virtual"
                    checked={isVirtual}
                    onChange={(e) => setIsVirtual(e.target.checked)}
                  />
                  <span className="appointment-virtual-slider" />
                </label>
                <span className={`appointment-virtual-label ${isVirtual ? 'active' : ''}`}>Sim</span>
              </div>
            </div>

            <div className="appointment-details-card">
              <span>Horário de início</span>
              <select name="start_time" value={startTime} onChange={(e) => setStartTime(e.target.value)}>
                <option value="">Selecione o horário de início</option>
                {generateTimeSlots().map((time) => (
                  <option key={time} value={time}>{time}</option>
                ))}
              </select>
            </div>

            <div className="appointment-details-card">
              <span>Horário de término</span>
              <select name="end_time" value={endTime} onChange={(e) => setEndTime(e.target.value)}>
                <option value="">Selecione o horário de término</option>
                {generateTimeSlots(true).map((time) => (
                  <option key={time} value={time}>{time}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="appointment-details-block">
            <p className="appointment-details-label">Observações</p>
            <textarea
              name="observation"
              value={observation}
              onChange={(e) => setObservation(e.target.value)}
              placeholder="Insira observações opcionais"
            />
          </div>

          <div className="appointment-create-actions">
            <button className="add-button" type="submit" disabled={isSubmittingAppointment}>
              {isSubmittingAppointment ? 'Salvando...' : 'Salvar agendamento'}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

// Subcomponente 3: AppointmentViewModal
function AppointmentViewModal({
  isOpen,
  closeModal,
  selectedAppointment,
  renderActionButtons,

  
}) {
  const getStatusPresentation = (appointment) => {
    if (!appointment) return { statusClass: '', statusLabel: 'N/A' };

    if (appointment.done) return { statusClass: 'appointment-done', statusLabel: 'Atendido' };
    if (appointment.reason_inactivation) return { statusClass: 'appointment-canceled', statusLabel: 'Cancelado' };
    if (appointment.status === 'Vencido') return { statusClass: 'appointment-expired', statusLabel: 'Expirado' };
    if (appointment.status === 'Vencendo') return { statusClass: 'appointment-warning', statusLabel: 'Vencendo' };
    return { statusClass: 'appointment-pending', statusLabel: 'Aguardando Atendimento' };
  };

  return (
    <Modal isOpen={isOpen} closeModal={closeModal} title={`Detalhes do Agendamento`}>
      {selectedAppointment && (
        <div className="appointment-details-modal">
          <div className="appointment-details-header">
            <div>
              <p className="appointment-details-label">Interno</p>
              <h4>{selectedAppointment.internal_name || 'Não informado'}</h4>
            </div>
            <span className={`appointment-details-status ${getStatusPresentation(selectedAppointment).statusClass}`}>
              {getStatusPresentation(selectedAppointment).statusLabel}
            </span>
          </div>

          <div className="appointment-details-grid">
            <div className="appointment-details-card">
              <span>Tipo de atendimento</span>
              <strong>{selectedAppointment.type_schedule_name || 'N/A'}</strong>
            </div>
            <div className="appointment-details-card">
              <span>Responsável</span>
              <strong>{selectedAppointment.user_name || 'N/A'}</strong>
            </div>
            <div className="appointment-details-card">
              <span>Data</span>
              <strong>{selectedAppointment.start_date ? new Date(selectedAppointment.start_date).toLocaleDateString('pt-BR') : 'N/A'}</strong>
            </div>
            <div className="appointment-details-card">
              <span>Pavilhão</span>
              <strong>{selectedAppointment.pavilion || 'N/A'}</strong>
            </div>
            <div className="appointment-details-card">
              <span>Cela</span>
              <strong>{selectedAppointment.cell || 'N/A'}</strong>
            </div>
            <div className="appointment-details-card">
              <span>Unidade</span>
              <strong>{selectedAppointment.unit || 'N/A'}</strong>
            </div>
            <div className="appointment-details-card">
              <span>Virtual</span>
              <strong>{selectedAppointment.virtual ? 'Sim' : 'Não'}</strong>
            </div>
          </div>

          <div className="appointment-details-block">
            <p className="appointment-details-label">Observações</p>
            <div className="appointment-details-text">
              {selectedAppointment.observation || 'Sem observações'}
            </div>
          </div>

          {selectedAppointment.reason_inactivation ? (
            <div className="appointment-details-block">
              <p className="appointment-details-label">Motivo do cancelamento</p>
              <div className="appointment-details-text">
                {selectedAppointment.reason_inactivation}
              </div>
            </div>
          ) : null}

          {renderActionButtons && renderActionButtons()}
        </div>
      )}
    </Modal>
  );
}
